<script>
  import 'scroll-scene-element';
  import DotPlots from './DotPlots.svelte';
  export let data;

  $: filter = '';
  $: rows = '';
  $: neighborhoods = '';
  $: gasconLabel = '';
  $: hochmanLabel = '';
  $: nbhAdjust = '';

  document.addEventListener('scroll-scene-enter', (event) => {
    // "event" is a CustomEvent, giving it has a `detail` property
    const detail = event.detail;
    // the triggering element
    const element = detail.element;
    const claim_order = element.claim_order;
    const eventFilter = element.dataset.filter;
    const eventRows = element.dataset.rows;
    const eventNbh = element.dataset.nbh;
    const eventAdjustments = element.dataset.adjust;

    // Set the prop updates as data for each scroll scene
    filter = eventFilter;
    rows = eventRows;
    neighborhoods = eventNbh;
    gasconLabel = element.dataset.gascon;
    hochmanLabel = element.dataset.hochman;
    nbhAdjust = element.dataset.adjust;

    const plot = document.getElementById("demographics-container");
  });

</script>

<DotPlots demo={data} 
          col='renter_percent'  
          filter={filter}
          start=''
          end=''
          rows={rows}
          neighborhoods={neighborhoods}
          gasconLabel={gasconLabel}
          hochmanLabel={hochmanLabel}
          nbhAdjust={nbhAdjust}
          />

<div class="scrollytelling-container">

  <scroll-scene class="scroll-scene" data-filter="" data-rows={['George Gascón']} data-nbh={[]} data-adjust='' data-gascon="true" data-hochman="false"><p>Most of the neighborhoods that <span class='candidate-1-underline'>Gascón</span> won are majority renters.</p>
  </scroll-scene>

  <scroll-scene class="scroll-scene" data-filter="" data-rows={['George Gascón']} data-nbh={['Echo Park']} data-adjust='' data-gascon="true" data-hochman="false"><p>In Echo Park, for example, 55% of the votes were for <span class='candidate-1-underline'>Gascón</span>, putting him far ahead of the second-place candidate, Deputy Dist. Atty. Jonathan Hatami. <br><br><span style="font-style: italic;">The size of the circle for <span class='neighborhood-underline'>Echo Park</span> is bigger, indicating more support.</span></p>
  </scroll-scene>

  <scroll-scene class="scroll-scene" data-filter="" data-rows={['George Gascón']} data-nbh={['Malibu']} data-adjust='' data-gascon="true" data-hochman="false"><p>On the Westside, <span class='neighborhood-underline'>Malibu</span> residents were split between the incumbent and Hochman. <br><br><span style="font-style: italic;">Less than 2 percentage points separate <span class='candidate-1-underline'>Gascón</span> from the next candidate, so the circle is smaller.</span></p>
  </scroll-scene>

  <scroll-scene class="scroll-scene" data-filter="" data-rows={['George Gascón', 'Nathan Hochman']} data-nbh={[]} data-adjust='' data-gascon="true" data-hochman="true"><p><span class='candidate-2-underline'>Hochman&rsquo;s</span> support, shown in purple below, mainly came from majority homeowner neighborhoods.</p>
  </scroll-scene>

  <scroll-scene class="scroll-scene" data-filter="majority_more_than_150k" data-rows={['George Gascón', 'Nathan Hochman']} data-nbh={['Palos Verdes Estates']} data-adjust='' data-gascon="true" data-hochman="true"><p>Most of <span class='candidate-2-underline'>Hochman&rsquo;s support</span> was from wealthier areas, neighborhoods where the majority of households make more than $150,000.</p>
  </scroll-scene>

  <scroll-scene class="scroll-scene" data-filter="majority_more_than_150k" data-rows={['George Gascón', 'Nathan Hochman']} data-nbh={['Pacific Palisades']} data-adjust='Pacific Palisades' data-gascon="true" data-hochman="true"><p><span class='candidate-1-underline'>Gascón narrowly</span> won in Pacific Palisades, but after the primary the area had one of the biggest increases in donations to <span class='candidate-2-underline'>Hochman.</span></p>
  </scroll-scene>

  <scroll-scene class="scroll-scene" data-filter="majority_lessthan60k" data-rows={['George Gascón', 'Nathan Hochman']} data-nbh={['Baldwin Hills/Crenshaw','Lincoln Heights','Northeast Antelope Valley']} data-adjust='Baldwin Hills/Crenshaw' data-gascon="true" data-hochman="true"><p>Neighborhoods where the majority of households make less than $60,000 overwhelmingly went for <span class='candidate-1-underline'>Gascón</span>.</p>
  </scroll-scene>

  <scroll-scene class="scroll-scene" data-filter="majority_black" data-rows={['George Gascón', 'Nathan Hochman']} data-nbh={['Leimert Park','Gramercy Park']} data-adjust='Gramercy Park' data-gascon="true" data-hochman="true"><p>All of the majority Black neighborhoods, mostly in South Los Angeles, voted for <span class='candidate-1-underline'>Gascón</span>. Deputy Dist. Atty. John McKinney, the only Black candidate, was the runnerup in these areas.</p>
  </scroll-scene>

<scroll-scene class="scroll-scene" data-filter="majority_latino" data-rows={['George Gascón', 'Nathan Hochman']} data-nbh={['El Sereno','Glassell Park', 'Lincoln Heights']} data-adjust='Glassell Park' data-gascon="true" data-hochman="true"><p>More than half of the majority Latino neighborhoods went for <span class='candidate-1-underline'>Gascón</span>.</p>
</scroll-scene>

<scroll-scene class="scroll-scene" data-filter="majority_latino" data-rows={['George Gascón', 'Nathan Hochman']} data-nbh={['El Sereno','Glassell Park', 'Lincoln Heights']} data-adjust='' data-gascon="true" data-hochman="true"><p></p>
</scroll-scene>
</div>